import { createRoutine } from 'redux-saga-routines';

const FETCH_ALL_ROLES_ACTION_PREFIX = 'FETCH_ALL_ROLES_ACTION';
export const fetchAllRolesAction = createRoutine(FETCH_ALL_ROLES_ACTION_PREFIX);
